import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitted(true);
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9kvo86c26n1c7c5qnt0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setFormError(serverMsg.includes('spam') ? '提交失败，请稍后重试' : serverMsg);
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          我要爆料
        </h2>

        <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70">
          <p className="text-sm text-foreground-600 text-center mb-6">
            您掌握内幕消息或黑料线索？请通过下方表单匿名提交。我们承诺严格保护投稿者隐私，所有投稿IP地址在存储时进行不可逆加密处理。
          </p>

          {submitted ? (
            <div className="text-center py-8">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-check-line text-3xl text-primary-500"></i>
              </div>
              <p className="text-base font-medium text-foreground-900">爆料已提交成功！</p>
              <p className="mt-1 text-sm text-foreground-600">我们将在48小时内进行审核处理，感谢您的爆料。</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-readdy-form="true" className="space-y-4">
              {formError && (
                <div className="bg-primary-50 text-primary-700 text-sm p-3 rounded-md border border-primary-200">
                  {formError}
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1">爆料标题 <span className="text-primary-500">*</span></label>
                <input
                  type="text"
                  name="title"
                  required
                  className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="简要描述爆料内容"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1">爆料分类 <span className="text-primary-500">*</span></label>
                <select
                  name="category"
                  required
                  className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                >
                  <option value="">请选择分类</option>
                  <option value="明星爆料">明星爆料</option>
                  <option value="网红黑料">网红黑料</option>
                  <option value="商业内幕">商业内幕</option>
                  <option value="社会热点">社会热点</option>
                  <option value="官场黑幕">官场黑幕</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1">详细描述 <span className="text-primary-500">*</span></label>
                <textarea
                  name="description"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请详细描述您掌握的内幕消息或黑料线索（限500字）"
                ></textarea>
                <p className="text-xs text-foreground-500 mt-1">限500字以内</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1">证据链接（选填）</label>
                <input
                  type="url"
                  name="evidence_url"
                  className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="如有相关图片、视频或文档链接，请粘贴在此"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1">联系方式（选填，仅用于核实）</label>
                <input
                  type="email"
                  name="email"
                  className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="如需我们与您联系核实，请留下邮箱"
                />
              </div>

              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>

              <button
                type="submit"
                className="w-full py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line mr-2"></i>匿名提交爆料
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}